import { useState, useEffect } from 'react'
import { Box, Button } from '@mui/material'
import { AttachFile } from '@mui/icons-material'

export function IssueAttachments({ attachments, getAttachmentUrl }) {
	const [urls, setUrls] = useState({})

	useEffect(() => {
		if (!attachments?.length) return

		const loadUrls = async () => {
			const result = {}
			for (const att of attachments) {
				try {
					result[att.id] = await getAttachmentUrl(att.file_path)
				} catch {
					result[att.id] = null
				}
			}
			setUrls(result)
		}
		loadUrls()
	}, [attachments, getAttachmentUrl])

	if (!attachments?.length) return null

	return (
		<Box display="flex" flexWrap="wrap" gap={1}>
			{attachments.map((att) => {
				const url = urls[att.id]
				const isImage = att.mime_type?.startsWith('image/')

				return (
					<Box key={att.id}>
						{url && isImage ? (
							<Box
								component="a"
								href={url}
								target="_blank"
								rel="noopener noreferrer"
								sx={{
									display: 'block',
									width: 120,
									height: 90,
									borderRadius: 1,
									overflow: 'hidden',
									border: 1,
									borderColor: 'divider',
								}}
							>
								<Box
									component="img"
									src={url}
									alt={att.file_name}
									sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
								/>
							</Box>
						) : (
							<Button
								size="small"
								href={url || '#'}
								target="_blank"
								rel="noopener noreferrer"
								disabled={!url}
								startIcon={<AttachFile />}
							>
								{att.file_name}
							</Button>
						)}
					</Box>
				)
			})}
		</Box>
	)
}
